import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 37"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15 .025a15.46 15.46 0 0 0-7.76 2.07 14.65 14.65 0 0 0-5.522 5.627 13.9 13.9 0 0 0-1.69 7.559 14 14 0 0 0 2.629 7.307q.093.177.225.33l.225.263c.21.26.425.513.61.72l9.836 11.473c.176.204.397.368.648.481.25.113.523.17.8.17.276 0 .55-.058.8-.172.251-.114.473-.28.649-.485L25.998 24.2q.58-.6 1.083-1.26l.239-.279a1.7 1.7 0 0 0 .228-.345 14 14 0 0 0 2.439-7.282 13.93 13.93 0 0 0-1.79-7.454 14.7 14.7 0 0 0-5.515-5.522A15.5 15.5 0 0 0 15 .025m0 9c1.113 0 2.2.317 3.125.91a5.45 5.45 0 0 1 2.072 2.424c.426.987.537 2.072.32 3.12a5.34 5.34 0 0 1-1.54 2.765 5.7 5.7 0 0 1-2.88 1.478 5.84 5.84 0 0 1-3.25-.308 5.6 5.6 0 0 1-2.524-1.989 5.25 5.25 0 0 1-.948-3c0-1.432.593-2.805 1.648-3.818A5.75 5.75 0 0 1 15 9.025"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }